<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
    <ion-button [routerLink]="['/inventory/location']">
        <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="confirmAlert(item()?.id ?? '', userId())" data-testid="location-detail-delete">
        <ion-icon
          slot="icon-only"
          color="danger"
          name="trash-outline"
        ></ion-icon>
      </ion-button>
      <ion-button (click)="openHelpModal()">
        <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{item()?.name}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <app-form
    [item]="item()!"
    [uid]="userId()!"
    (softUpdateLocation)="softUpdateLocation($event)"
  ></app-form>

  <div class="ion-padding-top">
    <ion-text color="medium">
      <h6>Inventory</h6>
    </ion-text>
    <ion-card class="ion-no-padding ion-no-margin">
      <ion-card-content class="ion-no-padding">
        @if ((allBeverages() && allBeverages().length > 0) || (allKegs() && allKegs().length > 0)) {
          <ion-searchbar [(ngModel)]="searchQuery" (ionInput)="onSearch($event)">
            </ion-searchbar>
        }
        <ion-list lines="full" class="ion-no-padding">

          @if (bottles() && bottles().length > 0) {
            <ion-list-header>
              <ion-label color="medium">Bottles</ion-label>
            </ion-list-header>
            @for (bottle of bottles(); track bottle.id) {
              <app-bottle [bottle]="bottle" [searchPhrase]="searchQuery"></app-bottle>
            }
          }
          
          @if (cans() && cans().length > 0) {
            <ion-list-header>
              <ion-label color="medium">Cans</ion-label>
            </ion-list-header>
            @for (can of cans(); track can.id) {
              <app-can [can]="can" [searchPhrase]="searchQuery"></app-can>
            }
          }
          
          @if (kegs2() && kegs2().length > 0) {
            <ion-list-header>
              <ion-label color="medium">Kegs</ion-label>
            </ion-list-header>
            @for (keg of kegs2(); track keg.id) {
              <app-keg [keg]="keg" [searchPhrase]="searchQuery"></app-keg>
            }
          }

          @if (co2s() && co2s().length > 0) {
            <ion-list-header>
              <ion-label color="medium">CO2</ion-label>
            </ion-list-header>
            @for (co2 of co2s(); track co2.id) {
              <app-location-co2 [co2]="co2"></app-location-co2>
            }
          }

        </ion-list>
      </ion-card-content>
    </ion-card>

  </div>
</ion-content>
